import "vue-app/utils/pubSubInitializer";
import { ReactNativeBridge } from "vue-app/utils/reactNativeBridge";
new ReactNativeBridge({ withRegistry: false });
import "../assets/scss/main.css";

import { createApp } from "vue";
import PagePasswordManagement from "../pages/PagePasswordManagement.vue";
import "./icons";
import TranslatePlugin from "../plugins/edroneTranslate/edroneTranslatePlugin";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

if (document.querySelector("#password")) {
  const app = createApp(PagePasswordManagement);
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.use(TranslatePlugin);
  app.mount("#password");
}
